import { whiteColor, primaryColor } from 'assets/jss/material-dashboard-pro-react';

const cellWithTooltipStyle = (theme) => ({
	wrapper: {
		display: 'flex',
		alignItems: 'center',
	},
	toolTip: {
		marginLeft: '10px',
		color: `${whiteColor} !important`,
		fontSize: theme.fontSize(14),
	},
	toolTipicon: {
		marginLeft: '10px',
		fontSize: theme.fontSize(16),
		fontWeight: 'bold',
		cursor: 'pointer',
		color: `${primaryColor[0]}`,
	},
	billNumberList: {
		padding: '10px',
		display: 'flex',
		flexDirection: 'column',
	},
});

export default cellWithTooltipStyle;
